"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEBT_CANDIDATE_ANSWER_COPY = void 0;
/**
 * BEN-141 FP-115: what each client says after a detected-debt-payment answer, one
 * copy for both (rule 17; web proposed the shared module).
 *
 * After "Not a debt" or a stopped-stream answer (paid off, paused, refinanced,
 * moved), the answered row becomes an in-place note with Undo that persists until
 * the user leaves the screen (Paul, 2026-10-07: option A; a timed Undo fails
 * screen-reader and large-text users, WCAG 2.2.1). "Add as a debt" can't be undone
 * from here (the server never withdraws a confirmed answer), so its note says what
 * to do instead, rather than offering nothing beside four answers that offer Undo.
 */
exports.DEBT_CANDIDATE_ANSWER_COPY = {
    notADebt: (payee) => `${payee} won't be suggested as a debt.`,
    /** `answer` is the button's label: "Paid off", "Paused", "Refinanced" or "Moved". */
    saved: (payee, answer) => `${payee}: saved as ${answer.toLowerCase()}.`,
    added: (payee) => `${payee} was added to your debts. To take it back, remove it from your debts.`,
    undo: "Undo",
    undoing: "Undoing…",
    undoFailed: "Couldn't undo. Try again.",
    /** The confirm form's heading and intro on setup's step 3 when a found debt is ticked
     *  (Paul 2026-10-23, option (b)): the candidate card's own words, which both cards still
     *  say inline (mobile's DE01 parity test reads web's card source for them). */
    confirmTitle: "Confirm this debt",
    confirmIntro: "Enter the terms from your lender's statement. We can't read them from your bank payments.",
};
//# sourceMappingURL=debtCandidateAnswerCopy.js.map